<template>
    <header
        :class="{
            thin: scrolled,
            white: navWhite,
            visible: navigationVisible,
            open: nav_open,
        }"
        class="app-header"
    >

        <div class="accessibility-feature non-quote-modal non-contact-modal">
            <div class="skip-links">
                <a href="#main-content" class="btn skip-link btn-primary">
                    Skip to Content
                </a>
                <a href="#site-footer" class="btn skip-link btn-primary">
                    Skip to Footer
                </a>
            </div>
        </div>

        <div class="container">
            <div class="logo">
                <a href="/" title="Flutter Developers">
                    <logo :colour="logoColour"/>
                </a>
            </div>
            <button
                :aria-expanded="nav_open"
                class="hamburger-menu"
                aria-haspopup="true"
                aria-controls="main-navigation"
                @click.prevent="toggleNav"
            >
                <span :class="{ open: nav_open }">
                    <span class="bar1"/>
                    <span class="bar2"/>
                    <span class="bar3"/>
                </span>
                <span class="sr-only">Toggle Menu</span>
            </button>
            <nav id="main-navigation" aria-label="Primary">
                <slot/>
            </nav>
        </div>
    </header>
</template>

<script>
    import Logo from './svgs/Logo';
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'app-header',

        components: {
            Logo,
        },

        data() {
            return {
                links: [
                    {
                        id: 2,
                        text: 'Services',
                        anchor: '#services',
                    },
                    {
                        id: 3,
                        text: 'About',
                        anchor: '#platforms',
                    },
                    {
                        id: 4,
                        text: 'Portfolio',
                        anchor: '#clients',
                    },
                    {
                        id: 5,
                        text: 'Quote',
                        anchor: '#testimonial',
                    },
                    {
                        id: 6,
                        text: 'Get in touch',
                        anchor: '#footer',
                        highlight: true,
                    },
                ],
                scrolled: false,
                nav_open: false,
            };
        },

        computed: {
            ...mapState('layout', [
                'activeSection',
                'styleVars',
                'navigationVisible',
            ]),

            ...mapGetters('layout', [
                'navShouldBeWhite',
            ]),

            /**
             * checks the active section
             *
             * @returns {boolean}
             */
            shouldBeThin() {
                return this.activeSection > 1;
            },

            /**
             * sets the logoColour color
             *
             * @returns {string}
             */
            logoColour() {
                if (window.Template.is('homepage')) {
                    return this.navShouldBeWhite
                        ? this.styleVars.secondaryColour
                        : '#FFF';
                }

                return this.styleVars.secondaryColour;
            },

            /**
             * sets the logoColour color
             * @returns {string}
             */
            navWhite() {
                if (window.Template.is('homepage')) {
                    return this.navShouldBeWhite;
                }

                return true;
            },
        },

        created() {
            window.addEventListener('scroll', this.handleScroll);
        },

        mounted() {
            setTimeout(() => {
                this.$store.commit('layout/showNavigation');
            }, 1000);

            window.addEventListener('resize',() => {
                this.hideMobileNav();
            });
        },

        methods: {
            /**
             * Handles scroll
             */
            handleScroll() {
                this.scrolled = window.scrollY > 0;
            },

            /**
             * Toggles mobile navigation bar
             *
             * Doesn't accept a param
             *
             * @param {Boolean} navOpen
             */
            toggleNav() {
                this.nav_open = !this.nav_open;
                $('body').toggleClass('noScroll', this.nav_open);
            },

            /**
             * Closes Hamburger menu after user clicks on the menu
             */
            closeMobileNav() {
                this.nav_open = false;
                $('body').toggleClass('noScroll', false);
            },

            /**
             * Hides the mobile navigation on desktop devices
             */
            hideMobileNav() {
                const width = $(window).width();
                if (width >= 768) {
                    this.nav_open = false;
                    $('body').toggleClass('noScroll', false);
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/vendor/bootstrap/variables";
    @import (reference) "~bootstrap/less/mixins/clearfix";
    @import (reference) "~assets/less/mixins/rem";
    @import (reference) "~assets/less/mixins/focus-visible";

    @keyframes glow {
        0% {
            box-shadow: 0px 0px 9px 6px #ffffff;
        }
        50% {
            box-shadow: 0px 0px 9px 4px #ffffff;
        }
        100% {
            box-shadow: 0px 0px 9px 6px #ffffff;
        }
    }

    @keyframes glow-blue {
        0% {
            box-shadow: 0px 0px 9px 6px fade(@secondary-colour, 75%);
        }
        50% {
            box-shadow: 0px 0px 9px 4px fade(@secondary-colour, 75%);
        }
        100% {
            box-shadow: 0px 0px 9px 6px fade(@secondary-colour, 75%);
        }
    }

    .skip-links {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1032;
        display: flex;
        flex-direction: column;
        font-size: 1.37rem;
        padding: 20px 15px 0;
        background-color: #e9eff4;
        transform: translateX(-100%);
        transition: transform .5s ease-in;

        @media (min-width: @screen-sm-min) {
            flex-direction: row;
            padding: 20px 0 20px 15px;
        }

        &:focus-within {
            transform: translateX(0);
        }
    }

    .skip-link {
        margin-bottom: 20px;
        @media (min-width: @screen-sm-min) {
            margin-right: 15px;
            margin-bottom: 0;
        }
    }

    .app-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        padding: 15px 0;
        z-index: @zindex-navbar-fixed;
        transition: 0.75s;
        background-color: transparent;
        opacity: 0;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);

        nav {
            font-family: 'futura-pt', sans-serif;
            .rem-font-size(25px);
            font-weight: 500;
            .rem-letter-spacing(-0.01px);
            padding: 4px 0;
            display: none;
            margin-top: 50px;

            @media (min-width: @screen-md-min) {
                display: block;
                .rem-font-size(17px);
                float: right;
                margin-top: 0;
                padding-top: 15px;
            }

            ul {
                margin: 0;
                padding: 0;
                list-style: none;
                .clearfix;
                li {
                    @media (min-width: @screen-md-min) {
                        float: left;
                        margin-left: 30px;
                        text-align: left;
                    }
                    &:first-child {
                        margin-left: 0;
                    }
                }
            }

            button,
            a {
                background-color: transparent;
                border: 0;
                color: #ffffff;
                display: block;
                position: relative;
                transition: 0.5s;
                transform: translateY(0);
                -webkit-transform: translateY(0);
                padding: 6px 12px;
                .rem-font-size(16px);
                width: 100%;
                .focus-visible;

                &.highlight {
                    border: 1px solid #FFFFFF;
                }

                &:hover,
                &:focus,
                &:active,
                &.active {
                    text-decoration: none;
                    color: @secondary-colour;
                    background-color: #e9eff4;
                }
            }
        }

        .logo {
            float: left;
            display: flex;
        }

        &.open {
            height: 100%;
            padding-top: 30px;
            overflow-y: scroll;
            transition: all .4s ease-in;
            background-color: fade(@secondary-colour, 96%);

            nav {
                margin-top: 50px;
                display: block;
                text-align: center;

                button,
                a {
                    margin-bottom: 15px;
                }
            }
        }

        &.visible {
            opacity: 1;
            transform: translateY(0);
            -webkit-transform: translateY(0);
        }

        &.white {
            background-color: fade(#ffffff, 96%);
            color: @secondary-colour;

            nav {
                button,
                a {
                    color: @secondary-colour;
                    background-color: transparent;
                    border: 0;

                    &.highlight {
                        border: 1px solid @secondary-colour;
                    }

                    &:hover,
                    &:focus,
                    &:active,
                    &.active {
                        text-decoration: none;
                        background-color: #e9eff4;
                    }
                }
            }
            .hamburger-menu {
                .bar1,
                .bar2,
                .bar3 {
                    background-color: @secondary-colour;
                }
            }
        }

        &.thin {
            padding: 10px 0;
        }

        .hamburger-menu {
            display: block;
            cursor: pointer;
            float: right;
            margin-top: 3px;
            background-color: transparent;
            border: 0;

            @media (min-width: @screen-md-min) {
                display: none;
            }

            .bar1,
            .bar2,
            .bar3 {
                display: block;
                width: 35px;
                height: 4px;
                background-color: #ffffff;
                margin: 6px 0;
                transition: .4s;
            }

            .open {
                .bar1 {
                    transform: rotate(-45deg) translate(-6px, 6px);
                    -webkit-transform: rotate(-45deg) translate(-6px, 6px);
                }
                .bar2 {
                    opacity: 0;
                }
                .bar3 {
                    transform: rotate(45deg) translate(-8px, -8px);
                    -webkit-transform: rotate(45deg) translate(-8px, -8px);
                }
            }
        }
    }
</style>
